// @flow strict
/* eslint-disable css-modules/no-undef-class */
import * as React from 'react';
import classNames from '@ta/common.classnames';
import { featureIsEnabled } from '@ta/common.features';
import { CdnImage } from '@ta/common.cdn';

import styles from './BrandedHeader.css';

/** These are styleguide-defined headers */
export type BrandedType = 'TA_GREEN' | 'TA_WHITE';

type Props = {|
  /** The styleguide-defined header type. Can be 'TA_GREEN' or 'TA_WHITE' */
  branding?: BrandedType,
|};

const BrandedHeader = (props: Props) => {
  let logo;
  let headerClass;
  let imgSourceWhite;
  let imgSourceGreen;
  if (featureIsEnabled('cx_brand_refresh_phase0')) {
    if (featureIsEnabled('dd_brand_refresh')) {
      imgSourceWhite = '/img2/langs/zh_CN/brand_refresh/Tripadvisor_lockup_horizontal_secondary_registered.svg';
      imgSourceGreen = '/img2/langs/zh_CN/brand_refresh/Tripadvisor_lockup_horizontal_secondary_registered.svg';
    } else {
      imgSourceWhite = '/img2/brand_refresh/Tripadvisor_lockup_horizontal.svg';
      imgSourceGreen = '/img2/brand_refresh/Tripadvisor_lockup_horizontal.svg';
    }
  } else {
    imgSourceWhite = '/img2/branding/rebrand/TA_logo_primary.svg'
    imgSourceGreen = '/img2/branding/rebrand/TA_logo_secondary.svg'
  }
  switch (props.branding) {
    case 'TA_WHITE':
      logo = {imgSourceWhite}
      headerClass = styles.brandedWhite;
      break;
    case 'TA_GREEN':
    default:
      logo = {imgSourceGreen}
      headerClass = styles.brandedGreen;
  }

  headerClass = classNames(styles.header, headerClass);

  return (
    <div className={headerClass}>
      <CdnImage className={styles.logo} src={logo} alt="TripAdvisor" />
    </div>
  );
};

BrandedHeader.defaultProps = {
  branding: 'TA_GREEN',
};

export default BrandedHeader;
